module.exports = __webpack_public_path__ + "static/media/palomaKit.ca372d86.png";